import { createReducer } from '@reduxjs/toolkit';

import { Organisation } from '../../../interfaces/organisation.interface';
import { getOrganisation, resetOrganisation, orgError } from '../actions/OrganisationActions';

export interface ReduxOrgState {
  org?: Organisation;
  orgLoaded: boolean;
  errors?: { message: string };
}

const initialState: ReduxOrgState = {
  org: undefined,
  orgLoaded: false,
};

const orgReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(getOrganisation, (state, action) => ({
      ...state,
      org: action.payload,
      orgLoaded: true,
      errors: undefined,
    }))
    .addCase(resetOrganisation, (state, action) => ({
      ...state,
      org: undefined,
      orgLoaded: false,
      errors: undefined,
    }))
    .addCase(orgError, (state, action) => ({
      ...state,
      errors: { message: action.payload },
    })),
);

export default orgReducer;
